// VENUES FILTER
document.querySelectorAll('.js-venues_filter').forEach((venuesFilter) => {
    const mod = venuesFilter.closest('.venues-block');
    const items = mod ? mod.querySelectorAll('.item') : [];
    const noMatchMessage = mod.querySelector('.venues-block__nomatch');

    if (!mod || items.length < 1) return;
    
    venuesFilter.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', () => {
            const formdata = new FormData(venuesFilter);
            const selectedFilters = Array.from(formdata.values());
            
            items.forEach((item) => {
                const itemTags = item.dataset.tags || '';
                const filterMatch = selectedFilters.every((val) => val === '' || itemTags.includes(val));
                item.classList.toggle('hidden', !filterMatch);
            });

            if (noMatchMessage) {
                const matchLength = mod.querySelectorAll('.item:not(.hidden)').length;
                noMatchMessage.classList.toggle('hidden', matchLength > 0);
            }

            mod.classList.add('filtered_anim');
            setTimeout(() => {
                mod.classList.remove('filtered_anim');
            }, 1000);
        });
    });

    venuesFilter.addEventListener('reset', () => {
        items.forEach((item) => item.classList.remove('hidden'));
        if (noMatchMessage) noMatchMessage.classList.add('hidden');

        mod.classList.add('filtered_anim');
        setTimeout(() => {
            mod.classList.remove('filtered_anim');
        }, 1000);
    });
});

// MAKE 2ND GDPR CHECKBOX REQUIRED
document.querySelectorAll('[name="subscribe"]').forEach( (field) => field.classList.add('required') );

// home top - CMS form - get mid-field
if(document.querySelectorAll('#formContainer .form-module__field').length > 0) {
    const midFieldIndex = Math.floor(document.querySelectorAll('#formContainer .form-module__field').length / 2) - 1;
    const maxInitialFields = Math.min(midFieldIndex, 4);
    document.querySelectorAll('#formContainer .form-module__field')[maxInitialFields]?.classList.add('mid-field');
}


//Form input animation
if(document.querySelectorAll('.field, .form-module__field').length > 0 ){
    document.querySelectorAll('.field, .form-module__field').forEach(field => {
        let FIELD_LABEL = field.querySelector('label:not(.hidden):not(.error)');
        let FIELD_INPUT = FIELD_LABEL.nextElementSibling;
        if(FIELD_INPUT){
            FIELD_INPUT.addEventListener('focus', function(){
                this.parentElement.classList.add('moved')
            })
            FIELD_INPUT.addEventListener('blur', function(){
                this.parentElement.classList.add('moved')
            })
        }

        // FILE INPUT
        if ( FIELD_INPUT?.getAttribute('type') === 'file' ) {
            field.classList.add('moved');
        }
    });
}

//Expand animation for homepage form
if(document.getElementById('formContainer')){
    document.getElementById('formContainer').querySelectorAll('.field, .form-module__field').forEach(field => {
        let FIELD_LABEL = field.getElementsByTagName('label')[0];
        let FIELD_INPUT = FIELD_LABEL.nextElementSibling;
        if(FIELD_INPUT){
            FIELD_INPUT.addEventListener('focus', function(){
                if(!document.getElementById('formContainer').classList.contains('opened')){
                    document.getElementById('formContainer').classList.add('opened');
                    document.getElementById('formContainer').querySelectorAll('.field.hidden').forEach(hidden => {
                        hidden.classList.remove('hidden')
                        hidden.classList.add('opened')
                    });
                    document.getElementById('formClose').parentElement.classList.remove('hidden')
                }
            })
        }
    })
    document.getElementById('formClose').addEventListener('click', function(){
        
        document.getElementById('formContainer').classList.remove('opened')
        this.parentElement.classList.add('hidden');
        // document.querySelector('[data-id="homeForm"]')
        document.getElementById('homeForm').querySelectorAll('.opened').forEach(hidden => {       
            hidden.classList.add('hidden')
            hidden.classList.remove('opened')
        });
    })
}

// ENABLE SUBMIT BUTTON WHEN REQUIRED FIELDS ARE FILLED
document.querySelectorAll('.leads-form').forEach((form) => {
    const $submitBtn = form.querySelector('[type="submit"]');

    form.querySelectorAll('.required').forEach((required) => {
        ['focus', 'keyup', 'change'].forEach((event) => {
            required.addEventListener(event, (e) => {
                setTimeout(() => {
                    const noErrorMessages = form.querySelectorAll('.error').length < 1;
                    const allRequiredFieldsFilled = Array.from(form.querySelectorAll('.required')).every(input => input.value.length > 0);
                    const allCheckboxCheked = Array.from(form.querySelectorAll('.required[type="checkbox"]')).every(checkbox => checkbox.checked);

                    if ($submitBtn && noErrorMessages && allRequiredFieldsFilled && allCheckboxCheked) {
                        $submitBtn.removeAttribute('disabled');
                    } else {
                        $submitBtn.setAttribute('disabled', 'disabled');
                    }
                }, 100); // wait for error message to appear/desappear
            });
        });
    });

});

// PHONE FORMAT VALIDATION
const phoneRegex = /[\d\.\-\+\(\)\s]/;
document.querySelectorAll('[type="tel"]').forEach((phone) => {
    phone.addEventListener('keydown', (e) => {

        if ( e.ctrlKey || e.altKey || typeof e.key !== 'string' || e.key.length !== 1 ) return;
        if ( !phoneRegex.test(e.key) ) e.preventDefault();

    }, false);
});


function checkRequiredFields() {
  const fields = document.querySelectorAll('.required');

  fields.forEach((field) => {
    const emptyVal = !field.value.trim();

    let label = field.previousElementSibling;
    if (!label || label.tagName !== 'LABEL') {
      label = field.nextElementSibling;
    }

    if (emptyVal && label && label.tagName === 'LABEL') {
      label.classList.add('error');
    } else if (label && label.tagName === 'LABEL') {
      label.classList.remove('error');
    }

    if (!field.dataset.listenerAttached) {
      field.addEventListener('input', () => {
        if (label && label.classList.contains('error') && field.value.trim()) {
          label.classList.remove('error');
        }
      });

      field.dataset.listenerAttached = 'true';
    }
  });
}

const sendForm = document.getElementById('send');
if(sendForm) {
    sendForm.addEventListener('click', () => {
        checkRequiredFields();
    })
}
/* document.getElementById('send').addEventListener('click', () => {
  checkRequiredFields();
}); */